import type { FC, InputHTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  error?: boolean;
}

export const baseInputClasses =
  'w-full appearance-none rounded-2xl border border-black/10 bg-[#f7f7f8] px-4 py-4 text-base leading-none text-black shadow-[inset_0_1px_2px_rgba(15,23,42,0.04)] outline-none transition-all duration-200 placeholder:text-black/35 focus:border-primary/60 focus:bg-white focus:ring-4 focus:ring-primary/10';
export const disabledInputClasses =
  'cursor-not-allowed border-gray-200 bg-gray-200 text-gray-400 focus:border-gray-200 focus:ring-0';
export const errorInputClasses =
  'border-red/40 bg-red/10 placeholder:text-red/75 focus:border-red/60 focus:ring-red/10';

export const TextInput: FC<TextInputProps> = ({
  className,
  error,
  disabled,
  ...props
}) => (
  <input
    type='text'
    disabled={disabled}
    {...props}
    className={twMerge(
      baseInputClasses,
      disabled && disabledInputClasses,
      error && errorInputClasses,
      className ?? ''
    )}
  />
);
